import { Typography } from "Components/atoms";
import { Form, Spinner } from "react-bootstrap";
import { ChangeEvent } from "react";
import ampyDefault from 'Assets/thumbnails/ampy_default.gif';
import './styles.scss';

interface ToggleableListItemProps {
  // MSB - TODO: remove key prop
    id: string;
    title: string;
    description: string;
    checked: boolean;
    disabled: boolean;
    advancedToggleView?: boolean;
    loading?: boolean;
    thumbnailUrl?: string;
    toggleLabel?: string;
    customDescriptionContent?: React.ReactNode;
    titleAccessory?: React.ReactNode;
    onChange: (_event: ChangeEvent<HTMLInputElement>) => void;
}

const getSimpleToggleView = (props: ToggleableListItemProps) => {
  const { id, title, description, checked, disabled, loading = false, onChange, titleAccessory } = props;
  return (
    <div className="toggleable-list-item d-flex flex-row justify-content-between align-items-center" id={`training-focus-${id}`}>
      <div className="flex flex-column structural-stroke-200">
        <div className="d-flex align-items-center gap-2 mb-1">
          <Typography variant="body2" color="text-high-emphasis" className="mb-0">{title}</Typography>
          {titleAccessory}
        </div>
        <Typography variant="body3" color="text-high-emphasis">{description}</Typography>
      </div>
      <div className="action-row toggle-row d-flex flex-row align-items-start">
        <Form.Check
          type="switch"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className="training-focus-switch"
          id={`training-focus-switch-${id}`}
        />
        {loading ? (
              <Spinner
                animation="border"
                size="sm"
                variant="text-interactive"
                role="status"
                aria-label="Saving..."
                className="spinner"
              />
        ) : <div className="empty-space"></div>}
      </div>
    </div>
  );
};

const getAdvancedToggleView = (props: ToggleableListItemProps) => {
  const { id, title, description, checked, disabled, loading = false, thumbnailUrl, toggleLabel, customDescriptionContent, onChange, titleAccessory } = props;
  return (
    <div className="toggleable-list-item" id={`training-focus-${id}`}>
      {/* Thumbnail Section */}
      <div className="module-thumbnail-col">
          <div className="thumbnail-wrapper">
              {thumbnailUrl ? (
                <img src={thumbnailUrl} alt={title} />
              ) : (
                // Fallback if thumbnail is not provided
                <div className="no-thumb-placeholder">
                    <img src={ampyDefault} alt="No thumbnail" />
                </div>
              )}
          </div>
      </div>
      <div className="module-info-col">
        <div className="d-flex align-items-center gap-2 mb-1">
          <Typography variant="body2" color="text-high-emphasis" className="mb-0">{title}</Typography>
          {titleAccessory}
        </div>
        <Typography variant="body3" color="text-medium-emphasis" className="module-description">{description}</Typography>
        {customDescriptionContent}
      </div>
      <div className="module-actions-col">
        <div className="action-row toggle-row">
          <Typography variant="caption1" color="text-medium-emphasis">
            {toggleLabel || `${checked ? 'Disable' : 'Enable'} ${title}`}
          </Typography>
          <div className="d-flex flex-row align-items-start">
            <Form.Check
              type="switch"
              checked={checked}
              disabled={disabled}
              onChange={onChange}
              className="training-focus-switch mt-2"
              id={`training-focus-switch-${id}`}
            />
            {loading ? (
              <Spinner
                animation="border"
                size="sm"
                variant="text-interactive"
                role="status"
                aria-label="Saving..."
                className="spinner"
              />
            ) : <div className="empty-space"></div>}
          </div>
        </div>
      </div>
    </div>
  );
};

const ToggleableListItem = (props: ToggleableListItemProps) => {
    return props.advancedToggleView ? getAdvancedToggleView(props) : getSimpleToggleView(props);
};

export default ToggleableListItem;